import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import queryString from 'query-string';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';
import { authenticate as authenticateAction } from './actions';
import {
  getIsAuthenticating,
  getAuthenticateError,
  getIsSignedIn
} from './selectors';
import { loginRoute } from '../../routes';
import { getLocalStorageItem } from '../utils/localStorage';
import Splash from '../../components/Splash';

export class Auth extends React.Component {
  componentDidMount() {
    const loginToken = this.getLoginToken();
    if (loginToken) {
      const { authenticate } = this.props;
      authenticate(loginToken);
    }
  }

  getLoginToken = () => {
    const { location } = this.props;
    return queryString.parse(location.search).loginToken;
  };

  render() {
    const { intl, isSignedIn, authenticateError } = this.props;

    const loginToken = this.getLoginToken();

    if (!loginToken) {
      return (
        <Redirect
          to={loginRoute({
            errorMessage: intl.formatMessage({ id: 'auth.noToken' })
          })}
        />
      );
    }

    if (authenticateError) {
      return <Redirect to={loginRoute({ errorMessage: authenticateError })} />;
    }

    if (isSignedIn) {
      return <Redirect to={getLocalStorageItem('redirect') || '/'} />;
    }

    return (
      <Splash
        content={
          <>
            <Typography gutterBottom align="center" variant="caption">
              <FormattedMessage id="auth.contentAuthorizing" />
            </Typography>
            <LinearProgress color="secondary" />
          </>
        }
      />
    );
  }
}

export default injectIntl(
  connect(
    state => ({
      isSignedIn: getIsSignedIn(state),
      isAuthenticating: getIsAuthenticating(state),
      authenticateError: getAuthenticateError(state)
    }),
    { authenticate: authenticateAction }
  )(ImmutablePropsToJS(Auth))
);
